<template>
    <div ref="pay-card-otp" id="pay-card-otp" class="opt-content-wrapper pay-pane active py-0 redirect">
        <div class="modal-body pb-1">
            <!-- ========================== EMPTY ACTIONS ====================== -->
            <div class="modal-body pb-1" v-if="options == null">
                <div class="text-center mt-3">
                    <div class="text-center">
                        <i class="title-icon warning"></i>
                    </div>
                    <h5 class="text-center gray mt-3 mb-5" style="line-height:1.5">No provider available for this
                        payment option. Kindly use other payment options</h5>
                </div>

                <div v-if="!loading && data.channels.length > 1" class="col-12 px-0 mt-4 text-center">
                    <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption"> &larr;
                        Choose another method </a>
                </div>
            </div>
            <!-- ========================== EMPTY ACTIONS ====================== -->

            <!-- ========================== NOT EMPTY ====================== -->
            <div v-else>

                <Spinner v-if="showLoader" class="animate slideInTop text-center mb-3 py-5"
                    :color="client_info.colors.loading_spinner">{{ mPassLoadingMessage }}</Spinner>

                <!-- Customer Processing Fees -->
                <p class="my-3 bold" v-if="showProcessingFeeMessage.length > 0" v-html="showProcessingFeeMessage"></p>
                <!-- Customer Processing Fees -->

                <!-- <p v-if="view !== 'custom'" class="text-center heading" :class="showLoader ? 'my-5 py-3' : (type == 'masterpass' && savedCards.length > 0 ?  'mt-0 mb-0' : 'my-5')" v-html="headingMessage"></p> -->

                <!-- ========================== OPTIONS LIST ====================== -->
                <div v-if="view == 'custom'" class="row mx-0">
                    <div class="options-list">
                        <p class="text-center heading mt-2" v-html="headingMessage"></p>
                        <ul class="mx-0 px-0  itemList v2-flex-container"
                            :style="options && options.length > 4 ? '{ flex-wrap: wrap }' : ''">
                            <li class="app-text-color fg-1" @click.prevent="pickCustomProvider(key)" :key="key"
                                :id="'list-' + key" v-for="(item, key) in options"
                                :style="{ 'color': `${client_info.colors.app}` }">
                                <img :src="item.image_url" alt="" />
                                <p class="title" v-html="item.option"></p>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- ========================== OPTIONS LIST ====================== -->

                <div v-else>

                    <!-- ========================== COMING SOON ====================== -->
                    <div class="modal-body pb-1" v-if="current_option == null || isComingSoon">
                        <div class="text-center mt-0">
                            <div class="modal-body text-center mb-0">
                                <!--h1 style="color: grey; width: 100%;">{{ data.option }}</-h1-->
                                <img v-if="current_option.image_url" :src="current_option.image_url"
                                    class="provider-logo" alt="" style="width: 20%; height :auto" />
                                <h4 style="" class="mt-3 gray">Coming Soon</h4>
                                <p class="mt-3 mb-5" style="font-size:14px;">
                                    <strong>{{ current_option.option }}</strong> is under development, please use other
                                    payment method.
                                </p>
                            </div>
                        </div>

                        <div v-if="!loading && this.data.channels.length > 1" class="col-12 px-0 mt-4 text-center">
                            <a v-if="options.length > 1" href="javascript:void(0)" class="text-tiny go-back"
                                @click.prevent="goBack">Go Back </a> <br><br>
                            <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption">
                                &larr; Choose another method </a>
                        </div>
                    </div>
                    <!-- ========================== COMING SOON ====================== -->

                    <div v-else>

                        <p v-if="view !== 'custom' && !showAccesButton" class="text-center heading"
                            :class="showLoader ? null : 'my-5 py-4'" v-html="headingMessage"></p>

                        <!-- ========================== REDIRECTION MESSAGE ====================== -->
                        <div v-if="showRedirection">
                            <div class="modal-body pb-1">
                                <p v-if="view !== 'custom'" class="text-center heading"
                                    :class="showLoader ? null : 'my-3 py-2'" v-html="headingMessage"></p>
                                <div v-if="showAccesButton" class="form-group mb-0 mt-4 text-center">
                                    <a v-if="options.length > 1" href="javascript:void(0)" class="text-tiny go-back"
                                        @click.prevent="goBack">Go Back </a> <br><br>
                                    <button type="button" class="btn app-bg-color" :style="button_color"
                                        @click.prevent="accessThirdParty">Yes, Continue Payment</button>
                                </div>
                            </div>

                        </div>
                        <!-- ========================== REDIRECTION MESSAGE ====================== -->
                        <!-- For Coming Soon-->
                        <div class="row m-0 text-center mb-4"
                            v-if="!showRedirection && current_option && current_option.provider && current_option.provider.toLowerCase() == 'coming soon'">
                            <h2 style="color: grey; width: 100%;">Coming Soon</h2>
                            <p> This feature is under development; please try other payment method.</p>
                        </div>
                    </div>

                </div>

                <!-- <div v-if="(!loading && this.data.channels.length > 1) || showRedirection" class="col-12 px-0 mt-3"> -->
                <div v-if="!showLoader && !isComingSoon">
                    <div v-if="(!loading && data.channels.length > 1)" class="col-12 px-0 mt-3">
                        <div class="mb-0 text-center">

                            <a href="javascript:void(0)" class="change-option" @click.prevent="changePaymentOption">
                                &larr; Choose another
                                method </a>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import Spinner from './includes/Spinner.vue';

const source = axios.CancelToken.source();
// axios.defaults.timeout = 60 * 3 * 1000;

export default {
    name: 'redirect',
    props: ['data', 'client_info', 'app_info', 'button_color'], // values resides here this.data.details
    components: {
        Spinner
    },

    created() {

        if (this.data) {
            // IFRAME REPLY
            // console.log(this.data.details);
            // console.log(this.data.details.custom_providers);
            /* if(this.data.details.details === undefined){
                window.failedFromStartMessage = "No provider is set for this option from the option call.";
                window.failedFromStart = false;
                let raw  = JSON.parse(window.raw);
                raw.message = "No provider is set for this option from the option call.";
                window.raw = JSON.stringify(raw);
                this.$router.push('/v2/warning');
            }else */

            if (this.data.details.source && this.data.details.source == 'iframeReply') {
                let transaction = this.data.details.transaction,
                    paymentMethod = this.$store.state.paymentMethodProvider;

                this.transaction = transaction;
                this.current_option = this.data.details.iframereply.provider

                if (paymentMethod == "masterpass") {
                    this.type = "masterpass"
                    this.mPassLoadingMessage = 'Checking Masterpass for your cards ..'
                    this.showRedirection = false
                    this.getMpassCard();
                } else if (paymentMethod == "ipg") {
                    this.type = "ipg"
                    this.mPassLoadingMessage = 'Validating payment ..'
                    let replyData = this.data.details.iframereply;
                    // console.log(replyData)
                    if (replyData.data.txnref != "")
                        this.validateCheckoutPaymentStatus(replyData.data.txnref, replyData.provider);
                    else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = replyData.data.desc;
                        let raw = JSON.parse(window.raw)
                        raw.message = replyData.data.desc
                        window.raw = JSON.stringify(raw);
                        this.$router.push('/v2/warning');
                        return;
                    }
                } else if (['opay', 'stripe', 'gbp', 'paystack', 'rhemitocardservice', 'gocardless', 'hydrogenpay', 'habaripay', 'habaripay', 'rhemitoaccountv2', 'payceler', 'fidelitympgs'].includes(paymentMethod)) {
                    this.type = paymentMethod; // Can be either opay, stripe or paystack
                    this.mPassLoadingMessage = 'Validating payment ..'
                    let replyData = this.data.details.iframereply;
                    this.validateCheckoutPaymentStatus(replyData.data.txnref, replyData.provider);

                    if (replyData.data.reference != "undefined" || replyData.data.reference != null) {
                        this.current_option = replyData.provider;
                        if (Object.keys(this.current_option).includes('extras') && this.current_option.extras != null) {
                            if (this.current_option.extras.customer_processing_fee_flat && parseFloat(this.current_option.extras
                                .customer_processing_fee_flat) > 0) {
                                let fees = parseFloat(this.current_option.extras.customer_processing_fee_flat);
                                this.$store.dispatch('customer_processing_fee', fees.toFixed(2));
                            } else if (this.current_option.extras.customer_processing_fee_percentage && parseFloat(this
                                .current_option.extras.customer_processing_fee_percentage) > 0) {
                                let percentage_price_as_flat = (parseFloat(this.$store.state.payload.transaction.amount) /
                                    100) * (parseFloat(this.current_option.extras.customer_processing_fee_percentage) / 100)
                                this.$store.dispatch('customer_processing_fee', percentage_price_as_flat.toFixed(2));
                            }
                        }

                        if (replyData.provider == 'paystack') {
                            this.pushPaystackToOnepipe(replyData.data.reference || replyData.data.trxref, replyData
                                .provider)
                        } else {
                            this.validateCheckoutPaymentStatus(replyData.data.txnref, replyData.provider);
                        }

                    } else {
                        this.loading = false;
                        window.failedFromStart = false;
                        if (replyData.provider == 'paystack') {
                            window.failedFromStartMessage =
                                "Paystack payment reference is missing. On your console, kindly check that your callback_url in your provider setting is have <strong>?provider=paystack</strong>";
                        } else {
                            window.failedFromStartMessage = "Unable to validate transaction";
                        }
                        let raw = JSON.parse(window.raw)
                        raw.message = raw.message = replyData.data.desc || "Unable to validate transaction";
                        window.raw = JSON.stringify(raw);
                        this.$router.push('/v2/warning');
                    }

                }
            } else { // IFRAME

                let options = this.data.details.custom_providers;
                // let options = this.data.details.action;

                this.transaction = this.data.details.transaction

                if (this.data.details.channels[this.data.details.index].action.length === 0) {
                    this.options = null;
                    return;
                }

                if (!options || options === undefined) { // Only One Provider
                    this.view == 'others';
                    this.current_option = this.data.details.details;
                    this.providers = this.data.details.channels[0];
                    this.type = this.current_option.provider.toLowerCase();
                    this.redirectUrl = this.current_option.custom_ui_url

                    if (this.current_option.instructions != "")
                        this.showLoader = false;

                    this.handleChosenProvider(this.type);

                } else if (options && Object.keys(this.data.details).includes(
                    "details")) { //coming from default view
                    this.current_option = this.data.details.details;
                    this.type = this.current_option.provider.toLowerCase();
                    this.redirectUrl = this.current_option.custom_ui_url

                    if (this.current_option.instructions != "")
                        this.showLoader = false;

                    this.handleChosenProvider(this.type);
                } else { // Has multiple custom ui providers
                    this.view = 'custom';
                    this.options = options;
                    this.headingMessage = this.data.details.channels[this.data.details.index].message
                    this.showLoader = false;
                    this.loading = false;
                }
            }
        }

    },

    watch: {
        view(val) {
            this.view = val
        },
        setActive(index) {
            this.active = index
        },
        redirectUrl(val) {
            this.redirectUrl = val
        },
        transaction(val) {
            this.transaction = val
        },
        isFocus(newVal) {
            if (newVal)
                this.focusColor = this.appColor
        }
    },
    data() {
        return {
            isComingSoon: false,
            focusColor: '',
            redirectUrl: '',
            mpassPin: '',
            view: '',
            current_option: {},
            paystack: {
                access_code: '',
                reference: '',
                authorization_url: '',
            },
            options: [],
            headingMessage: '',
            transaction: {},
            savedCards: [],
            selectedCard: {},
            details: {},
            showMpassPay: false,
            appColor: '',
            isFocus: true,
            showMPassCards: false,
            showMpassPin: false,
            countDownSeconds: 2,
            providers: [],
            provider: {},
            hoverKey: 0,
            hover: false,
            showLoader: true,
            type: '',
            mPassLoadingMessage: 'Loading...',
            loading: false,
            errors: {},
            showRedirection: false,
            showProcessingFeeMessage: '',
            showAccesButton: false,
        }
    },
    methods: {
        goBack() {
            this.isComingSoon = false;
            this.headingMessage = this.data.details.message
            this.current_option = ''
            this.view = 'custom'
            this.show_bank_list = false;
            this.isOTP = true;

            this.$store.dispatch('customer_processing_fee', 0.00);
            this.showProcessingFeeMessage = '';
            this.showRedirection = false;
            this.showAccesButton = false;
        },

        pickCustomProvider(index) {
            this.current_option = this.options[index];
            this.view = 'others';
            this.handleChosenProvider(this.current_option.provider);
        },

        handleChosenProvider(provider) {
            this.type = provider.toLowerCase();
            this.$store.dispatch('paymentMethodProvider', this.type)

            if (Object.keys(this.current_option).includes('extras') && this.current_option.extras != null) {
                if (this.current_option.extras.customer_processing_fee_flat && parseFloat(this.current_option.extras
                    .customer_processing_fee_flat) > 0) {
                    let fees = parseFloat(this.current_option.extras.customer_processing_fee_flat);
                    this.$store.dispatch('customer_processing_fee', fees.toFixed(2));
                    this.showProcessingFeeMessage =
                        ` A surcharge of <strong>₦${fees.toFixed(2)}</strong> has been added to your payment. `
                } else if (this.current_option.extras.customer_processing_fee_percentage && parseFloat(this
                    .current_option.extras.customer_processing_fee_percentage) > 0) {
                    let percentage_price_as_flat = (parseFloat(this.$store.state.payload.transaction.amount) /
                        100) * (parseFloat(this.current_option.extras.customer_processing_fee_percentage) / 100)
                    this.$store.dispatch('customer_processing_fee', percentage_price_as_flat.toFixed(2));
                    this.showProcessingFeeMessage =
                        ` A surcharge of <strong>₦${percentage_price_as_flat.toFixed(2)}</strong> has been added to your payment. `
                }
            }

            // Make Transact Call Here
            switch (provider.toLowerCase()) {
                case "comingsoon":
                    this.headingMessage = "";
                    this.isComingSoon = true;
                    break;

                case "paystack":
                case "opay":
                case "stripe":
                case "rhemitocardservice":
                case "gocardless":
                case 'hydrogenpay':
                case 'habaripay':
                case 'rhemitoaccount':
                case 'rhemitoaccountv2':
                case 'payceler':
                case 'fidelitympgs':
                    if (this.current_option.instructions && this.current_option.instructions != "")
                        this.headingMessage = this.current_option.instructions
                    else {
                        this.headingMessage = "Initializing transaction ..."
                    }

                    if (this.showProcessingFeeMessage.length > 0) {
                        this.showRedirection = true;
                        this.showAccesButton = true;
                        this.mPassLoadingMessage = ""
                    } else {
                        setTimeout(() => {
                            this.showLoader = true;
                            this.mPassLoadingMessage = "Initializing transaction ..."
                            if (provider.toLowerCase() == 'paystack') {
                                this.getPaystackPaymentUrl();
                            } else {
                                this.headingMessage = ""
                                this.transactCall(null, provider.toLowerCase() || 'opay');
                            }
                        }, 2500);
                    }
                    break;


                case "ipg":
                case "verve":
                    if (this.current_option.instructions && this.current_option.instructions != "")
                        this.headingMessage = this.current_option.instructions
                    else {
                        this.headingMessage = "Initializing transaction ..."
                    }

                    setTimeout(() => {
                        this.showLoader = true;
                        this.headingMessage = '';
                        this.mPassLoadingMessage = "Initializing transaction ..."
                        this.transactCall(null, 'ipg');
                    }, 2500);

                    break;


                default:
                    // Auto Submit
                    this.showLoader = false
                    this.showRedirection = true;
                    break;
            }
        },

        changePaymentOption() {
            // Cancel countdown
            clearInterval(window.countDown);
            this.$parent.changeComponent("PaymentOptions");
            this.$store.dispatch('customer_processing_fee', 0.00);
            this.showProcessingFeeMessage = '';
        },

        redirectTimer(data = null) {

            this.headingMessage = this.showProcessingFeeMessage = '';

            window.countDown = setInterval(() => {
                this.countDownSeconds--

                if (this.countDownSeconds <= 0) {
                    clearInterval(window.countDown);
                    let response = {};

                    switch (this.type.toLowerCase()) {
                        case 'ipg':
                        case 'verve':
                        case 'webpaydirect':

                            response = {
                                'status': 'redirect',
                                'data': {
                                    'form': data,
                                    'transaction': this.transaction,
                                    'redirectUrl': window.location.hostname == "localhost" ?
                                        `http://provider_redirect_ui.test/src/?appName=${this.app_info.name}` : `${this.current_option.custom_ui_url}?appName=${this.app_info.name}`,
                                    'siteRedirectUrl': window.location.hostname == "localhost" ?
                                        'http://provider_redirect_ui.test/src/redirect-status.php' : this.current_option
                                            .extras.callback_url ? this.current_option.extras.callback_url : "https://customui.dev.onepipe.io/redirect-status.php",
                                    'chargeUrl': data.chargeUrl,
                                    'sourceUrl': window.location.hostname == "localhost" ?
                                        'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                                    'provider': this.current_option,
                                }
                            }
                            break;

                        case 'opay':
                            response = {
                                'status': 'redirect',
                                'data': {
                                    'meta': data,
                                    'transaction': this.transaction,
                                    'redirectUrl': window.location.hostname == "localhost" ?
                                        `http://provider_redirect_ui.test/src/?appName=${this.app_info.name}` : `${this.current_option.custom_ui_url}?appName=${this.app_info.name}`,
                                    'siteRedirectUrl': window.location.hostname == "localhost" ?
                                        'http://provider_redirect_ui.test/src/redirect-status.php' : this.current_option
                                            .extras.callback_url ? this.current_option.extras.callback_url : "https://customui.dev.onepipe.io/redirect-status.php",
                                    'sourceUrl': window.location.hostname == "localhost" ?
                                        'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                                    'provider': this.current_option,
                                }
                            }

                            break;

                        default:
                        case 'mpgs':
                        case 'stripe':
                        case 'rhemitocardservice':
                        case 'gocardless':
                        case 'gbp':
                        case 'masterpass':
                        case 'paystack':
                        case 'hydrogenpay':
                        case 'rhemitoaccount':
                        case 'rhemitoaccountv2':
                        case 'payceler':
                        case 'habaripay':
                        case 'fidelitympgs':
                            response = {
                                'status': 'redirect',
                                'data': {
                                    'transaction': this.transaction,
                                    'redirectUrl': window.location.hostname === 'localhost' ?
                                        `http://provider_redirect_ui.test/src/?appName=${this.app_info.name}` : `${this.current_option.custom_ui_url}?appName=${this.app_info.name}`,
                                    'chargeUrl': data.iframeUrl || data.chargeUrl || this.current_option.custom_ui_url +
                                        '/redirect.php',
                                    'sourceUrl': window.location.hostname === 'localhost' ?
                                        'http://onepipejs.md/inline-v2.min.js' : 'https://js.dev.onepipe.io/v2', //window.parent.location.href,
                                    'provider': this.current_option,
                                }
                            }

                            if (this.type == 'paystack') {
                                response.callback_url = window.location.hostname === 'localhost' ?
                                    'http://provider_redirect_ui.test/src/' : this.current_option.extras
                                        .callback_url
                            }

                            break;
                    }

                    // console.log(response);
                    // delete response.current_option.extras

                    this.$parent.componentId = "";
                    window.parent.postMessage(JSON.stringify(response), '*');
                }
            }, 1000);
        },

        cancel() {
            clearInterval(window.countDown);
        },

        accessThirdParty() {
            this.showLoader = true;
            this.mPassLoadingMessage = "Initializing transaction ..."
            this.showAccesButton = false;
            this.headingMessage = this.showProcessingFeeMessage = '';
            this.current_option.provider
            this.getPaystackPaymentUrl();
            // this.transactCall(null, 'paystack');
        },

        transactCall(secure, type) {
            try {
                this.showLoader = true;
                this.headingMessage = '';
                this.mPassLoadingMessage = "Initializing transaction ...";

                let initialPayload = this.$store.state.payload;

                let payload = {
                    request_ref: initialPayload.request_ref,
                    request_type: initialPayload.request_type,
                    auth: {
                        "type": "custom",
                        "secure": secure,
                        "auth_provider": this.current_option.provider,
                    },
                    transaction: initialPayload.transaction
                }

                // Add customer_processing_fees
                if (this.$store.state.customer_processing_fee) {
                    payload.transaction.amount = parseInt(payload.transaction.amount) + parseInt(this.$store.state.customer_processing_fee.toString().replace('.', ''));
                }

                // check if the user is trying again, update the transaction ref
                payload.transaction.transaction_ref = this.$store.state.transRef
                if (this.$store.state.isFailed)
                    payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

                let data2 = {
                    api_key: this.$store.state.api_key,
                    endpoint: 'transact',
                    payload: payload
                }
                let data = this.$generateToken(data2);

                axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    headers: {
                        Authorization: `Bearer ${this.$store.state.payload.api_key}`
                    }
                }).then((response) => {
                    this.isLoading = false;
                    this.loadingMessage = 'Loading.. please wait';
                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    window.raw = JSON.stringify(res);

                    // Go and do the auto close popup on the status page instead of every pages.. it's more descent that way
                    if (status == "successful") {
                        this.isLoading = false;
                        this.$parent.changeComponent('Status', {
                            reference: payload.transaction.transaction_ref,
                            type: 'Successful',
                            data: responseData,
                            message: message || res.data.message
                        });
                    } else if (['pendingvalidation', 'processing'].includes(status)) {
                        if (this.showProcessingFeeMessage.length > 0) {
                            this.showRedirection = true;
                            this.showAccesButton = true;
                            // this.showLoader = true;
                            this.mPassLoadingMessage = ""
                        } else {
                            // this.headingMessage = "Initializing transaction ...";
                            let redirectFlowPayload = null;
                            switch (type.toLowerCase()) {
                                case 'ipg':
                                    redirectFlowPayload = {
                                        formData: responseData.provider_response.meta.formData,
                                        chargeUrl: responseData.provider_response.meta.formData.charge_url
                                    }
                                    break;

                                case 'opay':
                                    redirectFlowPayload = {
                                        orderNo: responseData.provider_response.meta.orderNo,
                                        reference: responseData.provider_response.meta.reference,
                                        chargeUrl: responseData.provider_response.meta.cashierUrl,
                                    }
                                    break;

                                case 'stripe':
                                case 'gbp':
                                case 'gocardless':
                                case 'rhemitocardservice':
                                case 'hydrogenpay':
                                case 'rhemitoaccount':
                                case 'rhemitoaccountv2':
                                case 'payceler':
                                case 'habaripay':
                                case 'fidelitympgs':
                                    redirectFlowPayload = {
                                        reference: responseData.provider_response.reference || responseData.provider_response.meta.reference,
                                        chargeUrl: responseData.provider_response.meta.redirect_url,
                                    }
                                    break;
                                case 'paystack':
                                    redirectFlowPayload = {
                                        iframeUrl: responseData.provider_response.meta.authorization_url,
                                    }
                                    break;

                                default: console.log(type);
                            }

                            if (redirectFlowPayload) {
                                setTimeout(() => {
                                    this.showLoader = true;
                                    this.mPassLoadingMessage = "Initializing transaction ..."
                                    this.redirectTimer(redirectFlowPayload);
                                }, 2500);
                            }
                        }

                    } else {
                        window.failedFromStart = false;
                        window.failedFromStartMessage = message || "Payment Failed."
                        this.$router.push('/v2/warning');
                    }
                }).catch(err => {
                    console.log(err)
                    window.raw = JSON.stringify(err);
                    window.failedFromStart = false;
                    window.failedFromStartMessage = err;
                    this.$router.push('/v2/warning');
                })
            } catch (err) {
                console.log(`Call OnePipe Error ${err}`)
                window.raw = JSON.stringify(err);
                window.failedFromStart = false;
                window.failedFromStartMessage = err;
                this.$router.push('/v2/warning');
            }

        },

        validateCheckoutPaymentStatus(ref, provider) {
            let intialPayload = this.$store.state.payload,
                payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: intialPayload.request_type,
                    auth: {
                        type: 'custom',
                        secure: ref || this.$store.state.transRef, //  IPG trxn ref
                        auth_provider: provider.provider
                    },
                    transaction: {
                        transaction_ref: this.$store.state.transRef,
                    }
                };

            if (this.$store.state.customer_processing_fee && parseFloat(this.$store.state.customer_processing_fee) > 0) {
                let cleanExtraCharges = this.$store.state.customer_processing_fee.toString().replace('.', '');
                payload.transaction.amount = (parseFloat(payload.transaction.amount) + parseFloat(cleanExtraCharges)).toString().replace('.', '');
            }

            if (this.$store.state.isFailed) {
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef
            }

            // Customer PRecessing Fee
            if (Object.keys(this.current_option).includes('extras') && this.current_option.extras != null) {
                if (this.current_option.extras.customer_processing_fee_flat && parseFloat(this.current_option.extras
                    .customer_processing_fee_flat) > 0) {
                    let fees = parseFloat(this.current_option.extras.customer_processing_fee_flat).toFixed(2).replace('.', '');
                    payload.transaction.amount = parseFloat(payload.transaction.amount) + parseFloat(fees)
                } else if (this.current_option.extras.customer_processing_fee_percentage && parseFloat(this
                    .current_option.extras.customer_processing_fee_percentage) > 0) {
                    let percentage_price_as_flat = ((parseFloat(this.$store.state.payload.transaction.amount) /
                        100) * (parseFloat(this.current_option.extras.customer_processing_fee_percentage) / 100)).toFixed(2).replace('.', '')
                    payload.transaction.amount = parseFloat(payload.transaction.amount) + parseFloat(percentage_price_as_flat);
                }
            }

            // Get status and show it to user
            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'query',
                payload
            };

            delete payload.api_key

            let data = this.$generateToken(data2);

            if (this.$store.state.isFailed)
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: `Bearer ${this.$store.state.payload.api_key}`
                }
            }).then(response => {
                let hash = response.data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                window.raw = JSON.stringify(res);

                if (response.status === 200) {
                    if (status == "successful") {
                        this.loading = false;

                        this.$parent.changeComponent('Status', {
                            reference: payload.transRef,
                            type: 'Successful',
                            data: responseData,
                            message: message || res.data.message
                        });

                    } else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/warning');
                    }
                } else {
                    console.log(response);
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                }
            })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })
        },

        getPaystackPaymentUrl() {

            if (this.transaction.customer.email == "null") {
                this.loading = false;
                window.failedFromStart = false;
                window.failedFromStartMessage = "Please supply a valid email in your payload";
                this.$router.push('warning');
                return;
            }

            let trx = this.$parent.deepClone(this.transaction);

            if (this.$store.state.customer_processing_fee) {
                trx.amount = parseInt(trx.amount) + parseInt(this.$store.state.customer_processing_fee.toString().replace('.', ''));
            }

            let headers = {
                'Content-type': 'application/json',
                Authorization: `Bearer ${this.current_option.extras.paystack_secret_key}`,
                'cache-control': 'no-cache',
            },
                params = {
                    email: this.transaction.customer.email,
                    callback_url: window.location.hostname === 'localhost' ?
                        'http://provider_redirect_ui.test/src/redirect-status.php?provider=paystack' : this.current_option
                            .extras.callback_url,
                    amount: trx.amount,
                    reference: this.$store.state.transRef,
                    meta: {
                        custom_fields: [{
                            display_name: this.transaction.customer.firstname + ' ' + this.transaction.customer.surname,
                            variable_name: "mobile_number",
                            value: this.transaction.customer.mobile_no
                        }]
                    }
                };


            if (Object.keys(this.current_option.extras).includes('split_code') && (this.current_option.extras.split_code != '' || this.current_option.extras.split_code != null)) {
                params.split_code = this.current_option.extras.split_code;
            }

            axios.post("https://api.paystack.co/transaction/initialize", params, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers,
                cancelToken: source.token
            }).then(response => {

                if (response.status === 200) {
                    var res = response.data;
                    window.raw = JSON.stringify(res.data);

                    // this.showLoader = false;
                    if (res.status) {
                        this.paystack = res.data
                        this.redirectTimer({
                            iframeUrl: res.data.authorization_url,
                        });

                        this.mPassLoadingMessage = "Waiting for response";
                    } else {
                        this.$store.dispatch('customer_processing_fee', 0.00);
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('warning');
                    }
                } else if (response.status === 400) {
                    this.$store.dispatch('customer_processing_fee', 0.00);
                    this.loading = false;
                    window.failedFromStart = false;
                    window.failedFromStartMessage = response.data.message || 'Bad Request';
                    this.$router.push('warning');
                } else {
                    this.$store.dispatch('customer_processing_fee', 0.00);
                    // console.log(response);
                    window.failedFromStart = false;
                    this.$router.push('warning');
                }
            })
                .catch(error => {
                    this.$store.dispatch('customer_processing_fee', 0.00);
                    // console.error(error
                    window.raw = JSON.stringify({
                        status: 'Failed',
                        message: error.response.data.message
                    }) || JSON.stringify(error);
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('warning');
                })

            // source.cancel('Operation canceled by the user.');
        },

        pushPaystackToOnepipe(ref, provider) {

            let randomId = this.$generateRequestRef(),
                payload = this.$parent.deepClone(this.$store.state.payload);

            payload.auth = {
                type: 'custom',
                secure: ref, //  Paystack trxn ref
                auth_provider: provider.provider
            }

            payload.transaction.transaction_ref = this.$store.state.transRef;
            payload.request_ref = randomId; // generate a new ref to call Onepipe.

            if (this.$store.state.isFailed)
                payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef

            // Customer PRecessing Fee
            if (Object.keys(this.current_option).includes('extras') && this.current_option.extras != null) {
                if (this.current_option.extras.customer_processing_fee_flat && parseFloat(this.current_option.extras
                    .customer_processing_fee_flat) > 0) {
                    let fees = parseFloat(this.current_option.extras.customer_processing_fee_flat).toFixed(2).replace('.', '');
                    payload.transaction.amount = parseFloat(payload.transaction.amount) + parseFloat(fees)
                } else if (this.current_option.extras.customer_processing_fee_percentage && parseFloat(this
                    .current_option.extras.customer_processing_fee_percentage) > 0) {
                    let percentage_price_as_flat = ((parseFloat(this.$store.state.payload.transaction.amount) /
                        100) * (parseFloat(this.current_option.extras.customer_processing_fee_percentage) / 100)).toFixed(2).replace('.', '')
                    payload.transaction.amount = parseFloat(payload.transaction.amount) + parseFloat(percentage_price_as_flat);
                }
            }

            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'transact',
                payload
            };

            delete payload.api_key

            let data = this.$generateToken(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: `Bearer ${this.$store.state.payload.api_key}`
                }
            }).then(response => {
                let hash = response.data.data,
                    res = this.$decodeToken(hash),
                    status = res.status.toLowerCase(),
                    message = res.message,
                    responseData = res.data;
                // console.log(res);
                window.raw = JSON.stringify(res);

                if (response.status === 200) {

                    if (status == "successful") {
                        this.loading = false;
                        this.$parent.changeComponent('Status', {
                            reference: payload.transRef,
                            type: 'Successful',
                            message: message || res.data.message,
                            data: responseData,
                        });

                    } else if (status == "waitingforotp") {
                        this.loading = false;
                        this.view = 'otp'
                        this.headingMessage = message || `Enter otp sent to ${this.$maskPhone(this.msisdn)}`
                        return;

                    } else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/warning');
                    }
                } else {
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                }
            })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/warning');
                })
        },

        getMpassCard() {

            // Call Lookup cards to fetch user's card

            let url = "https://masterpass.bits.dev.onepipe.io/get-cards";
            axios.post(url, {
                user_id: this.transaction.customer.mobile_no,
                hash: this.current_option.extras.api_key,
                user_id_type: this.current_option.extras.user_id_type,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'Bearer ' + this.$store.state.payload.api_key
                }
            })

                /* axios({
                method: 'post',
                url,
                timeout: 1000,
                data: {
                    user_id: this.transaction.customer.mobile_no,
                    api_key: this.current_option.extras.api_key,
                    user_id_type: this.current_option.extras.user_id_type,
                },
                headers: {
                    'Content-type': 'application/json',
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }) */

                .then(response => {
                    if (response.status === 200) {
                        var res = response.data;
                        // console.log(res)
                        window.raw = JSON.stringify(res.data);

                        this.showLoader = false;

                        if (res.status.toLowerCase() == "successful") {
                            if (res.data.provider_response.cards.length > 0) {
                                this.showLoader = false;
                                this.headingMessage = "YOUR CARDS";
                                this.savedCards = res.data.provider_response.cards;
                                this.view = 'others';
                                this.showMPassCards = true
                                this.showMpassPay = false
                                this.activeCardView = 1

                            } else {
                                this.showMPassCards = false
                                this.showMpassPay = true
                                this.mPassLoadingMessage =
                                    `This service is made possible by ${this.current_option.provider}. Because this is your first time, you may be required to set up a 5-digit PIN for your future security`;
                                // this.requestMpassUserWallet(this.transaction.customer.mobile_no);
                            }

                        } else {
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('warning');
                        }
                    } else {
                        window.failedFromStart = false;
                        this.$router.push('warning');
                    }
                })
                .catch(() => {
                    // console.warn(error);
                    let newRaw = JSON.parse(window.raw);
                    // console.log(newRaw);
                    newRaw.data.message = 'An error occured while fetching cards';
                    window.raw = JSON.stringify(newRaw);
                    window.failedFromStartMessage = 'An error occured while fetching cards';
                    window.failedFromStart = false;
                    this.$router.push('warning');
                })
        },

        requestMpassUserWallet(msisdn) {
            this.mPassLoadingMessage = "You'll be redirected to Masterpass page."
            let url = "https://masterpass.bits.dev.onepipe.io/get-wallet?msisdn=" + msisdn;
            let payload = {
                user_id: this.transaction.customer.mobile_no,
                hash: this.current_option.extras.api_key,
                user_id_type: this.current_option.extras.user_id_type,
                redirect_url: 'https://customui.dev.onepipe.io/redirect-status.php'
            };

            axios.post(url, payload, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                }
            }).then(response => {
                if (response.status === 200) {
                    var res = response.data;
                    // console.log(res)
                    window.raw = JSON.stringify(res.data);

                    if (res.status.toLowerCase() == "successful") {
                        if (res.data.provider_response.result.toLowerCase() === "success") {
                            // Prepare for redirect
                            this.redirectTimer({
                                iframeUrl: res.data.provider_response.url,
                            });

                            this.mPassLoadingMessage = "Waiting for response";
                        } else {
                            // Show error
                            this.loading = false;
                            window.failedFromStart = false;
                            window.failedFromStartMessage = res.message;
                            this.$router.push('warning');
                        }

                    } else {
                        this.loading = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('warning');
                    }
                } else {
                    window.failedFromStart = false;
                    this.$router.push('warning');
                }
            })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('warning');
                })
        },

        postMpassDebit() {
            if (this.mpassPin.length <= 0) {
                this.errors.mpassPin = true;
                this.otp_error_message = "Please supply your wallet pin code.";
                this.$refs.otpInput.focus();
                return;
            }

            this.showLoader = true;
            this.showMpassPin = false;

            this.mPassLoadingMessage = "Validating to debit your wallet..."

            // let initialPayload = this.$parent.getInitialPayload(),
            let randomId = this.$generateRequestRef(),
                payload = this.$store.state.payload;
            payload.auth = {
                type: 'custom',
                secure: `${this.transaction.customer.mobile_no};${this.selectedCard.cardId};${this.mpassPin.toString()}`, // customerId;cardId;pin
                auth_provider: this.current_option.provider
            }

            payload.request_ref = randomId; // generate a new ref to call Onepipe.
            // Get status and show it to user
            let data2 = {
                api_key: this.$store.state.api_key,
                endpoint: 'transact',
                payload
            };

            delete payload.api_key

            // if (this.$store.state.isFailed)
            data2.payload.transaction.transaction_ref_parent = this.$store.state.parentTransRef;

            data2.payload.transaction.transaction_ref = this.$store.state.transRef;

            let data = this.$generateToken(data2);

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                data,
            }, {
                timeout: this.API_CALL_TIMEOUT, // 3 mins
                headers: {
                    Authorization: 'bearer ' + this.$store.state.payload.api_key
                },
                cancelToken: source.token
            }).then(response => {
                if (response.status === 200) {

                    let hash = response.data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;

                    // console.log(res)
                    window.raw = JSON.stringify(res);

                    if (status == "successful") { // Check if user set autoclose for this payment method.
                        this.$parent.changeComponent('Status', {
                            // reference: payload.transaction.transaction_ref,
                            type: 'Successful',
                            status: 'Successful',
                            message: message || res.data.message,
                            data: responseData,
                        });

                    } else {
                        this.showLoader = false;
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('warning');
                    }
                } else {
                    window.failedFromStart = false;
                    this.$router.push('warning');
                }
            })
                .catch(error => {
                    // console.log(error.code);
                    // console.log(error.message);
                    // console.log(error.stack);
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('warning');
                })

            // source.cancel('Operation canceled by the user.');
        },

    }
};
</script>

<style scoped>
.v2-flex-container {
    display: flex !important;
    flex-flow: column wrap;
    transition: all .5s ease-in-out;
    -webkit-transition: all 0.5s ease-in-out;
    -moz-transition: all 0.5s ease-in-out;
    -ms-transition: all 0.5s ease-in-out;
    -o-transition: all 0.5s ease-in-out;
    border: solid 1px #ccc;
    border-radius: 5px;
    border-bottom: none;
    /* filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.6)); */
    webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);

}

ul.v2-flex-container li {
    list-style-type: none;
    height: 40px;
    cursor: pointer;
    background: #f5f5f578;
    font-size: 12px;
    padding: 8px 5px 8px 10px;
    border-bottom: #ded8d8 solid 1px;
    line-height: 40px;
}

/* border-radius: 5px 5px 0px 0px; */

ul.v2-flex-container li:first-child {
    border-radius: 5px 5px 0px 0px
}

ul.v2-flex-container li:last-child {
    /* border-bottom: none; */
    border-radius: 0px 0px 5px 5px;
}

ul.v2-flex-container li:hover,
ul.v2-flex-container li:focus {
    background: #e4e4e4;
    color: #000000 !important;
}

ul.v2-flex-container li>p:hover,
ul.v2-flex-container li>p:focus {
    color: #000000;
}

ul.v2-flex-container li img {
    height: 30px;
    width: 35px;
    line-height: 30px;
    margin-right: 20px;
    vertical-align: middle;
}

.options-list ul li p {
    font-weight: 600;
    vertical-align: middle;
    margin: 0%;
    display: inline-block;
    margin-right: 25px;
    height: 40px;
    line-height: 40px;
    width: 56.8%;
    text-align: left;
}

ul.v2-flex-container li::after {
    content: "\203A";
    font-weight: 300;
    font-size: 25px;
    float: right;
    margin-right: 15px;
}
</style>
